// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"fa0527ae","72":"073f73f7","477":"f88613ab","627":"f55ce93f","663":"cdd52171","667":"00f32c7d","777":"395ac711","803":"51434de9","820":"011d6903"}[chunkId] + ".chunk.js";
};